<!-- 充值弹框 -->
<template>
  <div class="recharge-dialog">
    <myModal
        class="recharge-modal"
        :width="'17rem'"
        :visible="visible"
        @close="close($event)"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="recharge-container">
          <div class="left">
            <div class="title">
              <img class="picon" src="@/assets/images/recharge/rechargeicon.png" alt=""/>
              <!-- <span>{{ $t("rechargeBalance") }}</span> -->
              <span>TOP UP</span>
            </div>
            <div class="line"></div>
            <div class="list-container">
              <div class="list-title">{{ $t("paymentMethods") }}</div>
              <div class="list-cards">
                <div
                    class="card-item"
                    :class="{ 'active-card': citem.id === activeCard.id }"
                    v-for="citem in paymentList"
                    :key="citem.id"
                >
                  <div class="card" @click="selectCard(citem)">
                    <img
                        class="addsend"
                        v-if="showAddSend(citem)"
                        src="@/assets/images/recharge/add10.png"
                        alt=""
                    />
                    <img class="card-icon" :src="citem.pc_img" alt=""/>
                    <!--                    <img class="card-icon" :src="citem.icon" alt=""/>-->
                    <!-- <span>{{ citem.name + ":" }}</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="back" @click="trackSource" v-if="currencyDetail.isShow===2">
              <a-space>
                <left-outlined/>
              </a-space>
              {{ $t("comeBackShort") }}
            </div>
            <!-- 银联 -->
            <div v-if="activeCard.type == 'currency' || activeCard.type == 'bank'">
              <div class="virtual-container">
                <template v-if="currencyDetail.isShow===0">
                  <!-- <div class="title">{{ $t("chooseAmount") }}</div> -->
                  <div class="gift-list">
                    <div
                        class="gift"
                        v-for="(cardItem, index) in activeCard.beansList"
                        :key="cardItem.id"
                        :class="{ 'active-gift': cardItem.id === currencyDetail.id }"
                        @click="handlePayNow(cardItem)"
                    >
                      <img :src="payBeansCardImg(cardItem, activeCard.type, activeCard.channel)" alt=""/>
                      <div
                          v-if="activeCard.id == 1 || activeCard.id == 7"
                          class="nowpay-price"
                      >
<!--                        {{ "$" + Math.trunc(cardItem.price) }}-->
                      </div>
                      <div
                          v-if="activeCard.id == 5 || activeCard.id == 6 || activeCard.id==8||activeCard.id==10||activeCard.id==11||activeCard.id==16"
                          class="gmpay-price"
                      >
<!--                        {{ "$" + Math.trunc(cardItem.price) }}-->
                      </div>
                    </div>
                  </div>
                  <div class="title title-info">{{ $t("rateInfo") }}</div>
                  <div class="v-coins" v-if="0">
                    <!-- <div
                      class="v-coin"
                      v-for="bean in activeCard.beansList"
                      :key="bean.id"
                    >
                      <div class="v-img">
                        <img src="@/assets/images/recharge/vbiicon.png" alt="" />
                      </div>
                      <div>Bitcoin</div>
                      <div>BTC</div>
                    </div> -->
                    <div
                        class="v-coin"
                        v-for="dItem in activeCard.digitalList"
                        :key="dItem.id"
                        v-debounce:500="() => handleDigitalCoin(dItem)"
                    >
                      <div class="v-img">
                        <img :src="dItem.icon" alt=""/>
                      </div>
                      <div class="v-name">{{ dItem.name }}</div>
                      <div class="v-alias">{{ dItem.alias }}</div>
                    </div>
                  </div>
                  <div class="promo-card" :class="{ 'is-verified': !!currencyDetail.promoCode }">
                      <div class="promo-hint" v-if="!currencyDetail.promoCode" @click="openPromoModal">
                        <span>{{ $t("promoClickToEnter") }}</span>
                        <span class="promo-arrow">›</span>
                      </div>
                      <template v-else>
                        <div class="promo-done-text">{{ $t("promoVerified", { code: currencyDetail.promoCode }) }}</div>
                        <div class="promo-done-msg" v-if="currencyDetail.promoMessage">{{ currencyDetail.promoMessage }}</div>
                        <span class="promo-clear" @click.stop="clearPromo">×</span>
                      </template>
                    </div>
                </template>
                <template v-else-if="currencyDetail.isShow===1">
                  <div class="coin-container">
                    <div class="coin-left">
                      <div class="back" @click="trackSource">
                        <a-space>
                          <left-outlined/>
                        </a-space>
                        {{ $t("comeBackShort") }}
                      </div>
                      <div class="qrcode" v-if="currencyDetail.resp.qr_url">
                        <vue-qr
                            :text="currencyDetail.resp.qr_url"
                            :margin="10"
                            :size="200"
                        ></vue-qr>
                      </div>
                      <div class="pay-info">
                        <span class="error">{{ $t("note") }}</span>
                        {{ $t("noticePayInfo") }}
                      </div>
                      <div class="require-info">
                        {{ currencyDetail.resp.pay_amount }}
                      </div>
                    </div>
                    <div class="coin-right">
                      <div class="title">
                        <img :src="currencyDetail.data.icon" alt=""/>
                        <span class="coin-name">{{ currencyDetail.data.name }}</span>
                      </div>
                      <div class="content">
                        <div class="t1">{{ $t("copyAddress") }}</div>
                        <div class="code-link">
                          <span class="gspan">{{ currencyDetail.resp.qr_url }}</span>
                          <img
                              @click="copyPromotionLink(currencyDetail.resp.qr_url)"
                              class="copy-icon"
                              src="@/assets/images/recharge/copyicon.png"
                              alt=""
                          />
                        </div>
                        <div class="info">
                          <img src="@/assets/images/recharge/info.png" alt=""/>
                          <span>{{ $t("depositingAddressInfo") }} </span>
                        </div>
                        <div class="title2">{{ $t("currentExchangeRate") }}</div>
                        <div class="code-link">
                          <span
                          >{{
                              currencyDetail.estimate.amount_from
                            }}{{ currencyDetail.estimate.currency_from || 0 }}=</span
                          >
                          <span class="balance">{{
                              currencyDetail.estimate.estimated_amount || 0
                            }}</span>
                        </div>
                        <div class="message">
                          <div class="m1">
                            <img src="@/assets/images/recharge/infored.png" alt=""/>
                            {{ $t("beforePayment") }}
                          </div>
                          <div class="mt">
                            {{
                              $t("beforePaymentInfo", {currency: currencyDetail.alias})
                            }}
                          </div>
                          <div class="mt">
                            <span class="note">{{ $t("note") }}</span>
                            {{ $t("rateInfo") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="currencyDetail.isShow===2">
                  <div class="telegram-container">
                    <div class="content-grid">
                      <!-- Method 1 -->
                      <div class="method-card">
                        <div class="method-badge">
                          {{ $t("tgRecharge1") }}
                        </div>
                        <h3 class="method-title">
                          {{ $t("tgRechargeTitle1-1") }}<br />
                          {{ $t("tgRechargeTitle1-2") }}
                        </h3>
                        <div class="qr-wrapper">
                          <div class="qr-container">
                            <vue-qr
                                :text="currencyDetail.resp.qr_url"
                                :margin="0"
                                :size="100"
                                class="qr-image"
                            ></vue-qr>
                          </div>
                        </div>
                        <div class="price-info">
                          <span class="price-usd">$ {{ currencyDetail.data.price }}</span>
                          <span class="price-separator">≈</span>
                          <span class="price-stars"><img src="@/assets/images/bank/tgstars.png" alt=""> {{ currencyDetail.data.star }}</span>
                        </div>
                      </div>
                      <!-- Method 2 -->
                      <div class="method-card">
                        <div class="method-badge">
                          {{ $t("tgRecharge2") }}
                        </div>
                        <h3 class="method-title method-title-spaced">
                          {{ $t("tgRechargeTitle2-1") }}<br />
                          {{ $t("tgRechargeTitle2-2") }}
                        </h3>
                        <div class="button-wrapper">
                          <button class="telegram-button" @click="handleTelegramRecharge(currencyDetail)">
                            {{ $t("tgRecharge2Button") }}
                          </button>
                          <p class="notice-text">
                            {{ $t("tgRecharge2Noitce") }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="promo-card" :class="{ 'is-verified': !!currencyDetail.promoCode }">
                      <div class="promo-hint" v-if="!currencyDetail.promoCode" @click="openPromoModal">
                        <span>{{ $t("promoClickToEnter") }}</span>
                        <span class="promo-arrow">›</span>
                      </div>
                      <template v-else>
                        <div class="promo-done-text">{{ $t("promoVerified", { code: currencyDetail.promoCode }) }}</div>
                        <div class="promo-done-msg" v-if="currencyDetail.promoMessage">{{ currencyDetail.promoMessage }}</div>
                        <span class="promo-clear" @click.stop="clearPromo">×</span>
                      </template>
                    </div>
                </template>
              </div>
            </div>

            <!-- 礼品卡 -->
            <div v-else-if="activeCard.type == 'cards'">
              <div class="gift-container">
                <div class="gift-list">
                  <div
                      class="gift"
                      v-for="cardItem in activeCard.beansList"
                      :key="cardItem.id"
                      @click="handleGiftCard(cardItem)"
                  >
                    <img :src="payBeansCardImg(cardItem, activeCard.type, activeCard.channel)" alt=""/>
<!--                    <span class="gift-price">{{ Math.trunc(cardItem.price) }}</span>-->
                  </div>
                </div>
                <div class="gift-info">
                  {{ $t("giftCardInfo") }}
                </div>
                <div class="promocode">
                  <div class="title col promo-title-row">
                    <span class="promo-title-text">{{ $t("useGiftCard") }}</span>
                    <span class="promo-inline-link" v-if="!currencyDetail.promoCode" @click="openPromoModal">
                      {{ $t("promoClickToEnter") }}<i class="promo-arrow">›</i>
                    </span>
                    <span class="promo-inline-done" v-else>
                      {{ $t("promoVerified", { code: currencyDetail.promoCode }) }}
                      <b class="promo-clear" @click.stop="clearPromo">×</b>
                    </span>
                  </div>
                  <div class="input-container single-input col">
                    <a-input
                        type="text"
                        :placeholder="$t('inputPromocode')"
                        v-model:value="cardCode"
                    />
                    <a-button
                        :class="btnIsAble(cardCode)"
                        :disabled="!cardCode"
                        @click="handleKaMiPay"
                    >{{ $t("rechargeBtnUse") }}
                    </a-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- skrill   skinsback -->
            <div v-else-if="activeCard.type == 'skin'">
              <div class="skinsback-container">
                <div class="block">
                  <div class="info">
                    {{ $t("minPayBeans") }} <span class="balance">2.00</span>
                  </div>

                  <div class="promo-banner">
                    <img src="@/assets/images/recharge/skinsback1.jpg" alt="" class="banner-bg"/>
                  </div>

                  <div class="tip-bar">
                    <img src="@/assets/images/bank/info.png" alt="">
                    <div class="tip-content">
                      <span v-if="skinpayRiskLevel === 'vip'">{{ $t("skinsPayBankInfo4") }}</span>
                      <span v-else-if="skinpayRiskLevel === 'normal'">{{ $t("skinsPayBankInfoNormal") }}</span>
                      <span v-else-if="skinpayRiskLevel === 'high'">{{ $t("skinsPayBankInfoHigh") }}</span>
                      <span v-else>{{ $t("skinsPayBankInfo4") }}</span>
                      <span class="tip-rust-dota">{{ $t("skinsPayRustDotaInfo") }}</span>
                    </div>
                  </div>
                  <!--                  <div class="tips">Due to recent CS2 Trading Protection updates, skin payments are temporarily unavailable.</div>-->

                  <div class="btn" @click="handlePayForSkinsBack">
                    <a-button>{{ $t("btnCheckout") }}</a-button>
                  </div>
                </div>
                  <div class="promo-card" :class="{ 'is-verified': !!currencyDetail.promoCode }">
                    <div class="promo-hint" v-if="!currencyDetail.promoCode" @click="openPromoModal">
                      <span>{{ $t("promoClickToEnter") }}</span>
                      <span class="promo-arrow">›</span>
                    </div>
                    <template v-else>
                      <div class="promo-done-text">{{ $t("promoVerified", { code: currencyDetail.promoCode }) }}</div>
                      <div class="promo-done-msg" v-if="currencyDetail.promoMessage">{{ currencyDetail.promoMessage }}</div>
                      <span class="promo-clear" @click.stop="clearPromo">×</span>
                    </template>
                  </div>
              </div>
            </div>

            <!-- telegram -->

            <div v-else>
              <!--              默认显示银行-->
              <div class="virtual-container">
                <template v-if="currencyDetail.isShow===0">
                  <!-- <div class="title">{{ $t("chooseAmount") }}</div> -->
                  <div class="gift-list">
                    <div
                        class="gift"
                        v-for="(cardItem, index) in activeCard.beansList"
                        :key="cardItem.id"
                        :class="{ 'active-gift': cardItem.id === currencyDetail.id }"
                        @click="handlePayNow(cardItem)"
                    >
                      <img :src="payBeansCardImg(cardItem, activeCard.type, activeCard.channel)" alt=""/>
                      <div
                          v-if="activeCard.id == 1 || activeCard.id == 7"
                          class="nowpay-price"
                      >
                        {{ "$" + Math.trunc(cardItem.price) }}
                      </div>
                      <div
                          v-if="activeCard.id == 5 || activeCard.id == 6 || activeCard.id==8||activeCard.id==10||activeCard.id==11||activeCard.id==16"
                          class="gmpay-price"
                      >
                        {{ "$" + Math.trunc(cardItem.price) }}
                      </div>
                    </div>
                  </div>
                  <div class="title title-info">{{ $t("rateInfo") }}</div>

                  <div class="promo-card" :class="{ 'is-verified': !!currencyDetail.promoCode }">
                      <div class="promo-hint" v-if="!currencyDetail.promoCode" @click="openPromoModal">
                        <span>{{ $t("promoClickToEnter") }}</span>
                        <span class="promo-arrow">›</span>
                      </div>
                      <template v-else>
                        <div class="promo-done-text">{{ $t("promoVerified", { code: currencyDetail.promoCode }) }}</div>
                        <div class="promo-done-msg" v-if="currencyDetail.promoMessage">{{ currencyDetail.promoMessage }}</div>
                        <span class="promo-clear" @click.stop="clearPromo">×</span>
                      </template>
                    </div>
                </template>
                <template v-else-if="currencyDetail.isShow===1">
                  <div class="coin-container">
                    <div class="coin-left">
                      <div class="back" @click="trackSource">
                        <a-space>
                          <left-outlined/>
                        </a-space>
                        {{ $t("comeBackShort") }}
                      </div>
                      <div class="qrcode" v-if="currencyDetail.resp.qr_url">
                        <vue-qr
                            :text="currencyDetail.resp.qr_url"
                            :margin="10"
                            :size="200"
                        ></vue-qr>
                      </div>
                      <div class="pay-info">
                        <span class="error">{{ $t("note") }}</span>
                        {{ $t("noticePayInfo") }}
                      </div>
                      <div class="require-info">
                        {{ currencyDetail.resp.pay_amount }}
                      </div>
                    </div>
                    <div class="coin-right">
                      <div class="title">
                        <img :src="currencyDetail.data.icon" alt=""/>
                        <span class="coin-name">{{ currencyDetail.data.name }}</span>
                      </div>
                      <div class="content">
                        <div class="t1">{{ $t("copyAddress") }}</div>
                        <div class="code-link">
                          <span class="gspan">{{ currencyDetail.resp.qr_url }}</span>
                          <img
                              @click="copyPromotionLink(currencyDetail.resp.qr_url)"
                              class="copy-icon"
                              src="@/assets/images/recharge/copyicon.png"
                              alt=""
                          />
                        </div>
                        <div class="info">
                          <img src="@/assets/images/recharge/info.png" alt=""/>
                          <span>{{ $t("depositingAddressInfo") }} </span>
                        </div>
                        <div class="title2">{{ $t("currentExchangeRate") }}</div>
                        <div class="code-link">
                          <span
                          >{{
                              currencyDetail.estimate.amount_from
                            }}{{ currencyDetail.estimate.currency_from || 0 }}=</span
                          >
                          <span class="balance">{{
                              currencyDetail.estimate.estimated_amount || 0
                            }}</span>
                        </div>
                        <div class="message">
                          <div class="m1">
                            <img src="@/assets/images/recharge/infored.png" alt=""/>
                            {{ $t("beforePayment") }}
                          </div>
                          <div class="mt">
                            {{
                              $t("beforePaymentInfo", {currency: currencyDetail.alias})
                            }}
                          </div>
                          <div class="mt">
                            <span class="note">{{ $t("note") }}</span>
                            {{ $t("rateInfo") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </myModal>

    <!-- 风控邮件确认弹框 -->
    <myModal
        class="risk-confirm-modal"
        :visible="riskConfirmVisible"
        @close="closeRiskConfirm"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="risk-confirm-body">
          <div class="risk-title">⚠️ {{ $t('riskConfirmTitle') }}</div>
          <div class="risk-desc">{{ $t('riskConfirmDesc') }}</div>
          <!-- 银行卡支付时显示卡号和持卡人信息 -->
          <template v-if="isCardPayment">
            <div class="risk-field">
              <div class="risk-field-title">Card Number</div>
              <div class="risk-card-number">
                <div class="risk-card-segment">
                  <a-input
                    v-model:value="riskCardFirst"
                    type="text"
                    placeholder="First 6"
                    maxlength="6"
                    @input="riskCardFirst = riskCardFirst.replace(/[^\d]/g, ''); riskCardError = ''"
                  />
                </div>
                <div class="risk-card-dots">• • • • • •</div>
                <div class="risk-card-segment">
                  <a-input
                    v-model:value="riskCardLast"
                    type="text"
                    placeholder="Last 4"
                    maxlength="4"
                    @input="riskCardLast = riskCardLast.replace(/[^\d]/g, ''); riskCardError = ''"
                  />
                </div>
              </div>
              <div class="risk-field-error" v-if="riskCardError">{{ riskCardError }}</div>
            </div>
            <div class="risk-field">
              <div class="risk-field-title">Cardholder Name</div>
              <div class="risk-input-wrapper">
                <a-input
                  v-model:value="riskCardHolder"
                  type="text"
                  placeholder="Enter cardholder name"
                  @input="riskHolderError = ''"
                />
              </div>
              <div class="risk-field-error" v-if="riskHolderError">{{ riskHolderError }}</div>
            </div>
          </template>
          <div class="risk-field">
            <div class="risk-field-title">Email</div>
            <div class="risk-input-wrapper">
              <a-input
                v-model:value="riskEmail"
                type="email"
                :placeholder="$t('riskEmailPlaceholder')"
                @pressEnter="sendRiskConfirmation"
              />
            </div>
          </div>
          <div class="risk-field-error" v-if="riskEmailError">{{ riskEmailError }}</div>
          <div class="risk-btns">
            <a-button class="risk-send-btn" :loading="riskSending" :disabled="riskEmailSent" @click="sendRiskConfirmation">
              {{ riskEmailSent ? $t('riskSentBtn') : $t('riskSendBtn') }}
            </a-button>
          </div>
          <div class="risk-waiting" v-if="riskEmailSent">
            <div class="risk-waiting-text">{{ $t('riskWaiting') }}</div>
            <div class="risk-timer">{{ riskCountdown }}s</div>
          </div>
        </div>
      </template>
    </myModal>

    <!-- 风控到账方式提示弹框（Normal/High） -->
    <myModal
        class="risk-payout-modal"
        :visible="riskPayoutVisible"
        @close="closeRiskPayout"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="risk-payout-body">
          <div class="risk-title">⚠️ {{ $t('riskPayoutTitle') }}</div>
          <div class="risk-desc" v-if="riskPayoutLevel === 'normal'">
            {{ $t('riskPayoutNormal') }}
          </div>
          <div class="risk-desc" v-else-if="riskPayoutLevel === 'high'">
            {{ $t('riskPayoutHigh') }}
          </div>
          <div class="risk-btns">
            <span class="payout-countdown">{{ $t('autoClose') }} {{ payoutCountdown }}s</span>
          </div>
        </div>
      </template>
    </myModal>

    <!-- 风控拒绝提示弹框 -->
    <myModal
        class="risk-reject-modal"
        :visible="riskRejectVisible"
        @close="riskRejectVisible = false"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="risk-reject-body">
          <div class="risk-reject-icon">🚫</div>
          <div class="risk-reject-title">{{ $t('riskRejectTitle') }}</div>
          <div class="risk-reject-desc">{{ $t('riskRejectDesc') }}</div>
          <a-button class="risk-reject-btn" @click="riskRejectVisible = false">OK</a-button>
        </div>
      </template>
    </myModal>

    <!-- 充值结果提示弹框 -->
    <myModal
        class="recharge-result-modal"
        :visible="resultVisible"
        @close="closeResult($event)"
    >
      <template #cuscloseIcon>
        <img src="@/assets/images/systemicon/close.png" alt=""/>
      </template>
      <template #body>
        <div class="tips">TIPS</div>
        <div class="content">
          <div class="info">
            <img :src="resultImg" alt=""/>
            <div class="infos">
              {{ $t(resultInfo) }}
            </div>
          </div>
          <a-button class="result-btn" @click="closeResult($event)"
          >{{ resultBtnTxt }}
          </a-button>
        </div>
      </template>
    </myModal>

    <myModal
        class="promo-code-modal"
        :width="'5.5rem'"
        :visible="promoModalVisible"
        @close="promoModalVisible = false"
    >
      <template #mytitle>{{ $t("promocode") }}</template>
      <template #body>
        <div class="promo-modal-body">
          <a-input
              v-model:value="promoInput"
              type="text"
              :placeholder="$t('inputPromocode')"
              @pressEnter="submitPromo"
              @input="promoError = ''"
          />
          <div class="promo-modal-err" v-if="promoError">{{ promoError }}</div>
          <a-button class="promo-ok-btn" :loading="promoLoading" @click="submitPromo">{{ $t("addL") }}</a-button>
        </div>
      </template>
    </myModal>
  </div>
</template>

<script setup>
import {LeftOutlined} from "@ant-design/icons-vue";
import {computed, ref, watch} from "vue";
import eventEmitter from "@/utils/emitter.js";
import {getImageUrlByNewURL} from "@/utils/getImageUrl.js";
import showNotice from "@/components/common/notice/notice.js";
import $api from "@/api";
import i18n from "@/i18n";
import vueQr from "vue-qr/src/packages/vue-qr.vue";
import {useRouter} from "vue-router";
// import { useGtag } from 'vue-gtag-next'
// const gtag = useGtag()
import useClipboard from "vue-clipboard3";
import handleResponse from "@/utils/handleResponseData.js";
import $store from "@/store";
import {StandardEvents, useFbPixel} from '@/utils/useFbPixel.js'
import useStore from '@/store';
const deviceStore = useStore('deviceInfo')();
const { trackEvent } = useFbPixel({
  pixelId: import.meta.env.VITE_META_PIXEL_ID
})

const {toClipboard} = useClipboard();
const {t: $t, locale} = i18n.global;
const router = useRouter();
const userStore = $store("user");
console.log("userStore:", userStore);
// import { useFbq } from "vue3-facebook-pixel";
// const fbq = useFbq();
const copyPromotionLink = async (targetVal) => {
  //js 复制值到剪切板
  console.log("要复制的目标值:", targetVal);

  try {
    await toClipboard(targetVal);
    console.log("Copied to clipboard");
    showNotice("s", {
      desc: "复制成功",
    });
  } catch (e) {
    console.log(e);
  }
};

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["closed", "api:pay"]);

//当前选中的支付方式
// const activeCard = ref({ id: 1, type: "giftcard", beansList: [], digitalList: [] });

const activeCard = ref({});

let type_temp = '';
//卡密充值对应档位图片
const giftCardImg = computed(() => {
  //此处不能用proxy.$getImageUrlByNewURL 是因为充值组件是另外一个vue实例,就是说createApp render新创建的vue应用程序,跟main.js的vue app不是同一个实例,所以不能用proxy.$getImageUrlByNewURL,除非在创建充值弹框的地方全局添加属性
  return (card, type) => {
    const priceStr = Math.floor(card.price);
    let imgsrc = "";
    if (type == "cards") {
      imgsrc = getImageUrlByNewURL("recharge/card" + Math.trunc(card.price) + ".png");
    }
    console.log("imgsrc:", imgsrc);
    return imgsrc;
  };
});

/**
 * todo
 * nowpayments gmpay(gmpayMasterCard and gmpayPix)  gmapyshuzi 点击金币充值档位都用 handlePayNow 处理
 * nowpayments  和 gmpayshuzi  右侧充值金币档位样式相同
 * gmpay(gmpayMasterCard and gmpayPix) 金币档位样式图片单独处理
 * gmpaysbp(c6n) and gmpayMasterCard 充值金币样式一致
 * overpaysbp+overpayvisi 和 gmpaySbp(c6n)样式一样
 */
//nowpayments and gmpay 充值对应档位图片
//支付通道金币icon样式动态显示
const payBeansCardImg = computed(() => {
  return (card, type, channel) => {
    // 2026-10-13 统一取图目录：cards / bank / 其它 统一用 recharge/card{N}.png
    // （card/ 与 gmpaycards/、telegram/ 三个目录内容逐字节相同，无需分目录维护）
    // 加密货币类（currency）仍用 recharge/nowpay/{N}.png
    const n = Math.trunc(card.price);
    if (type === "currency") {
      return getImageUrlByNewURL("recharge/nowpay/" + n + ".png");
    }
    return getImageUrlByNewURL("recharge/card" + n + ".png");
  }
})

//选择支付方式
function selectCard(item) {
  if(type_temp) {
    activeCard.value.type = type_temp;
    type_temp = '';
  }
  if (item.id == activeCard.value.id) {
    return;
  }
  resetcurrencyDetail();
  activeCard.value.beansList = [];
  console.log("item;", item);
  // activeCard.value.id = item.id;
  // activeCard.value.type = item.type;
  activeCard.value = item;
  //根据channel 显示对应支付方式的金币列表
  if (item.type == "cards") {
    //卡密支付方式写死,其余支付方式动态渲染
    getBeansList(item.channel);
  } else {
    if (item.type == "currency") {
      //数字货币1列表
      activeCard.value.digitalList = digitalList1;
      console.log("list;", activeCard.value.digitalList);
      currencyDetail.value.pay_way = item.pay_way; //res.data[0]为nowpay;res.data[1]为skinpay
      getBeansList(item.channel);

      // getPaymentList().then((res) => {
      //   //数字货币1列表
      //   activeCard.value.digitalList = digitalList1;
      //   console.log("res;", res);
      //   console.log("list;", activeCard.value.digitalList);
      //   // activeCard.value.beansList = [];
      //   currencyDetail.value.pay_way = res.data[0].pay_way; //res.data[0]为nowpay;res.data[1]为skinpay
      //   getBeansList(res.data[0].channel);
      // });
    } else if (item.type === "skin") {
      currencyDetail.value.pay_way = item.pay_way; //res.data[0]为nowpay;res.data[1]为skinpay
      // 获取 skinpay 风控等级
      $api.user.riskStatus().then((res) => {
        if (res && res.code === 200 && res.data) {
          skinpayRiskLevel.value = res.data.skinpay_level || res.data.risk_level || 'vip';
        }
      }).catch(() => {
        skinpayRiskLevel.value = 'vip';
      });
    } else if (item.type === "telegram") {
      currencyDetail.value.pay_way = item.pay_way; //res.data[0]为nowpay;res.data[1]为skinpay
    } else {
      //gmpay 金币列表
      // activeCard.value.digitalList = ''
      // console.log("list;", activeCard.value.digitalList);
      currencyDetail.value.pay_way = item.pay_way;
      getBeansList(item.channel);
    }
  }
}

//选择指定支付方式的金币列表
function getBeansList(channel) {
  if (!props.visible) {
    return;
  }
  console.log("showCoins", channel);
  $api.user.getBeansList({params: {channel}}).then((res) => {
    console.log("getBeansList", res);
    activeCard.value.beansList = res.data;
    // currencyDetail.value.pay_way = res.data[0].pay_way;
    currencyDetail.value.id = activeCard.value.beansList[0].id;
  });
}

//点击卡密列表跳转卡密平台
function handleGiftCard(item) {
  const params = {
    id: item.id,
    client_id: localStorage.getItem('ga4_client_id')
  };
  const invite_id = localStorage.getItem("invite_id");
  if(invite_id === 'AJPC001' || invite_id === 'AJYD001'){
    trackEvent(StandardEvents.ADD_TO_CART, {
      content_ids: ['skinroll_'+item.id],
      content_type: 'product',
      value: item.price,
      currency: 'USD'
    })
  }
  $api.user.ga4Checkout(params).then((res) => {
    window.open(item.card_link);
  });
}

//卡密充值-礼品卡
const cardCode = ref("");

//点击使用卡密支付
function handleKaMiPay() {
  console.log("卡密充值");
  $api.user.handleKaMiRecharge({card: (cardCode.value || '').replace(/\s+/g, ''),client_id: localStorage.getItem('ga4_client_id'),coupon_code: (currencyDetail.value.promoCode || '').trim() || undefined}).then((res) => {   // [FIX-CARD] 去空白
    console.log("卡密充值成功", res);
    if (res.code == 200) {
      // if (res.fb_event === "PURCHASE") {
      //   fbq.event("Purchase", {
      //     currency: "USD",
      //     value: "1",
      //   });
      // }
      showNotice("s", {
        desc: res.message,
      });
      //关闭充值弹框
      close();
      userStore.getUserInfo().then((res) => {
        console.log("卡密充值成功,更新用户账户;", res);
      });
    } else {
      showNotice("f", {
        desc: res.message,
      });
    }
  })
    .catch((err) => {
      console.error("卡密充值失败:", err);
      const msg = (err && (err.message || (err.data && err.data.message))) || "Recharge failed, please retry";
      proxy.$notice("f", { desc: msg });
    });
}

//skinsback充值
function handleSkinsback() {
  console.log("skinsback充值");
}

const btnIsAble = computed(() => {
  return (code) => {
    return code ? "able-btn" : "disable-btn";
  };
});

//虚拟币处理对象
const currencyDetail = ref({
  isShow: 0, //默认显示虚拟货币一级页面,为true显示虚拟货币充值汇率详情页面
  id: -1, //金币充值列表 虚拟币当前选中的充值金额id
  pay_way: -1, //充值方式
  alias: "", //币种-BTN DOGE等
  data: [], //点击选中的虚拟货币对象数据
  resp: {}, //当前选中虚拟货币充值返回数据
  estimate: {}, //汇率接口返回数据
  promoCode: "", //优惠码
});

//重置虚拟币处理对象
function resetcurrencyDetail(isReset = true) {
  currencyDetail.value.isShow = 0;
  if (isReset) {
    currencyDetail.value.id = -1; //金币充值列表 虚拟币当前选中的充值金额id
    currencyDetail.value.pay_way = -1; //充值方式
  }
  currencyDetail.value.data = [];
  currencyDetail.value.resp = {};
  currencyDetail.value.estimate = {};
  currencyDetail.value.promoCode = ""; //优惠码
}


//虚拟币选择要充值的档位
function selectCurrency(item) {
  // currencyDetail.value.id = item.id;
}

// nowpayment and gmpay 充值 跳外链 telegram 二维码充值
// 方案A：先创建充值订单，拿到订单号后再做风控检查
// [PROMO-CODE 2026-10-14] 活动码卡片：点击输入 → /api/promo/check 校验 → 已验证
const promoModalVisible = ref(false);
const promoInput = ref("");
const promoError = ref("");
const promoLoading = ref(false);

function openPromoModal() {
  promoInput.value = currencyDetail.value.promoCode || "";
  promoError.value = "";
  promoModalVisible.value = true;
}

function submitPromo() {
  const code = (promoInput.value || "").trim();
  if (!code) {
    promoError.value = i18n.global.t("inputPromocode");
    return;
  }
  promoLoading.value = true;
  promoError.value = "";
  $api.user.promoCheck({ code: code }).then((res) => {
    promoLoading.value = false;
    if (res.code == 200 && res.data) {
      currencyDetail.value.promoCode = code;
      currencyDetail.value.promoMessage = res.data.message || "";
      promoModalVisible.value = false;
    } else {
      promoError.value = (res && res.message) ? res.message : "Invalid promo code";
    }
  }).catch(() => {
    promoLoading.value = false;
    promoError.value = "Network error, please retry";
  });
}

function clearPromo() {
  currencyDetail.value.promoCode = "";
  currencyDetail.value.promoMessage = "";
}

function handlePayNow(carditem) {
  let params={};
  console.log("nowpayment充值", carditem);
  if (currencyDetail.value.pay_way === 16) {
    currencyDetail.value.data = carditem;
    currencyDetail.value.data.star = carditem.price * 64;
    params = {
      pay_way: currencyDetail.value.pay_way,
      type: 'qrcode',
      id: carditem.id,
      coupon_code: currencyDetail.value.promoCode || undefined,
      client_id: localStorage.getItem('ga4_client_id')
    };
  }
  else if(currencyDetail.value.pay_way === 18 || currencyDetail.value.pay_way === 19 || currencyDetail.value.pay_way === 20
      || currencyDetail.value.pay_way === 21 || currencyDetail.value.pay_way === 22 || currencyDetail.value.pay_way === 23
      || currencyDetail.value.pay_way === 24 || currencyDetail.value.pay_way === 25 || currencyDetail.value.pay_way === 26
      || currencyDetail.value.pay_way === 27 || currencyDetail.value.pay_way === 28 || currencyDetail.value.pay_way === 29){
    params = {
      country: deviceStore.country,
      terminal_type: 'WEB',
      device_id: deviceStore.rayid,
      device_brand: deviceStore.platform,
      device_model: deviceStore.device,
      client_ip: deviceStore.ip,
      pay_way: currencyDetail.value.pay_way,
      id: carditem.id,
      coupon_code: currencyDetail.value.promoCode || undefined,
      client_id: localStorage.getItem('ga4_client_id')
    };
  }
  else{
    params = {
      pay_way: currencyDetail.value.pay_way,
      id: carditem.id,
      coupon_code: currencyDetail.value.promoCode || undefined,
      client_id: localStorage.getItem('ga4_client_id')
    };
  }
  console.log("params;", params);

  // 调用后端充值接口（后端内部处理风控）
  $api.user.handleRecharge(params).then((res) => {
    console.log("recharge res;", res);
    if (res.code != 200) {
      return showNotice("f", {desc: res.message});
    }

    // 后端返回 action 决定下一步
    const action = res.action || 'allow';
    if (action === 'reject') {
      // 风控拒绝
      riskRejectVisible.value = true;
      return;
    }
    if (action === 'challenge') {
      // 风控挑战 → 弹确认框
      riskOrderNo.value = res.out_trade_no || '';
      riskCardItem.value = carditem;
      riskPaymentUrl = res.list?.qr_url || '';
      riskConfirmVisible.value = true;
      return;
    }
    // allow → 直接打开支付页面
    if (currencyDetail.value.pay_way === 16) {
      currencyDetail.value.isShow = 2;
      currencyDetail.value.resp.qr_url = res.list.qr_url;
    } else {
      const winOpen = window.open("", "_blank");
      winOpen.location = res.list.qr_url;
    }
  });

  //通过监听websocket推送PayNoify 来获取虚拟货币充值结果

  //每10s监听600次   10分钟总时长-10分钟后销毁监听或中间监听到状态为支付成功则销毁监听
  // const sendData = {
  //   MsgType: "Controls",
  //   ApiCode: "bean_detail",
  //   Param: {
  //     code: out_trade_no,
  //     user_id: userStore.userInfo.id,
  //     access_token: getToken(),
  //   },
  // };
  // //websocket 发送参数 转成json字符串
  // const jsondata = JSON.stringify(sendData);
  // eventEmitter.emit("api:bean_detail", jsondata);

  //bug 当充值多次时如何处理监听
  //---以最后一次充值的订单号来监听充值状态,后端推送充值状态以前端发送websocket命令为准,前端发一次,后端就会返回一次
}
function handleTelegramRecharge(item) {
  console.log("handleTelegramRecharge;", item);
  let params = {
    pay_way: item.pay_way, //充值方式
    type: 'message',
    id: item.data.id, //充值金额id
    coupon_code: (currencyDetail.value.promoCode || '').trim() || undefined,   // [FIX-TG 2026-10-14] 原读 item.promoCode，但后端 beans 无此字段 ⇒ 恒 undefined ⇒ 活动码在此路径静默失效
    client_id: localStorage.getItem('ga4_client_id')
  };
  console.log("params;", params);
  $api.user.handleRecharge(params).then((res) => {
    console.log("telegram payment res;", res);
    if (res.code !== 200) {
      handleBindTelegram();
      return showNotice("f", {desc: res.message});
    }
    currencyDetail.value.isShow = 2;
    currencyDetail.value.resp.qr_url = res.list.qr_url;
  });
}
function handleBindTelegram() {
  console.log("telegram binding");
  const params = {
    uid: userStore.userInfo.id,
  }
  $api.user.telegramLogin({params: params}).then((res) => {
    console.log("telegram res url;", res);
    window.location.href = res.url;
  });
}

//监听充值订单状态是否成功
function payStatus(ordercode) {
  payTimer.value = setInterval(() => {
    if (paySuccess.value) {
      $api.user.beanDetail({params: {code: ordercode}}).then((res) => {
        console.log("充值订单详情", res);
        //若充值成功 弹框提示用户充值已到账,同时用户余额更新
        if (res.code == 200) {
          // if (res.code == 1) {
          //   //表示充值成功
          //   //弹框提示用户充值成功
          //   //用户余额更新
          // }
          if (res.data.status == 1) {
            showNotice("s", {
              desc: $t("paySuccess"),
            });
            console.log("充值已到账,更新余额");

            paySuccess.value = false;
            userStore.getUserInfo().then((res) => {
              console.log("登录成功,更新用户数据;", res);
            });
            console.log("用户余额已更新,清除定时器");
            clearInterval(payTimer.value);
            clearInterval(indateTimer.value);
            console.log("定时器清除完毕");
            //关闭充值弹框
            close();
          }
          console.log("测试监听订单定时器编号 timer:", payTimer.value);
        } else {
          showNotice("f", {
            desc: res.message,
          });
          clearInterval(payTimer.value);
          clearInterval(indateTimer.value);
        }
      });
    }
  }, 3000);
}

const payTimer = ref(null); //监听订单定时器
const indateTimer = ref(); //监听过期订单定时器
const paySuccess = ref(true); //支付成功确认

//数字货币充值
function handleDigitalCoin(item) {
  console.log("handleDigitalCoin", item);
  if (currencyDetail.value.id == -1) {
    return showNotice("f", {desc: "请选择充值金额"});
  }
  currencyDetail.value.alias = item.alias;
  //调用充值接口-生成链接和二维码
  const params = {
    currency: item.currency,
    pay_way: currencyDetail.value.pay_way, //充值方式
    id: currencyDetail.value.id, //充值金额id
    client_id: localStorage.getItem('ga4_client_id')
  };
  console.log("params;", params);
  // return;
  $api.user.handleRecharge(params).then((res) => {
    console.log("handleRecharge", res);
    const html = res.html;
    const out_trade_no = res.out_trade_no;
    // payStatus(out_trade_no); //传入当前充值订单号

    //监听订单是否过期 -每隔20s生成新的二维码
    //当前时间戳(保留10  保留到秒) 加20s
    //20s+当前时间戳传给qrloose indate
    // Code参数:订单号  indate参数:过期时间(10位时间戳,到秒)
    // 返回支付链接转成二维码
    indateTimer.value = setInterval(() => {
      const timeC = Math.floor(Date.now() / 1000) + 20;
      const newUrl = `${
          import.meta.env.VITE_API_BASE_URL
      }/qrLoose?code=${out_trade_no}&indate=${timeC}`;
      // currencyDetail.value.resp.qr_url = newUrl;
      console.log("20s重新生成", newUrl);
    }, 1000 * 20);

    const type = res.type;
    currencyDetail.value.resp.qr_url = html.data.qr_url;
    currencyDetail.value.resp.pay_amount = html.data.pay_amount;
    currencyDetail.value.resp.out_trade_no = out_trade_no;
    currencyDetail.value.resp.type = type;

    currencyDetail.value.isShow = 1;
    currencyDetail.value.data = item;

    //调用汇率接口
    const params2 = {
      amount: 1,
      currency_from: item.alias,
      currency_to: "usd",
    };
    console.log("汇率参数:", params2);
    $api.user.getEstimate(params2).then((res) => {
      console.log("汇率接口返回;", res);
      currencyDetail.value.estimate = res.data;
      //js 字符串转大写
      currencyDetail.value.estimate.currency_from =
          currencyDetail.value.estimate?.currency_from?.toUpperCase() || 0;
    });
  });
}

//skinsback支付
function handlePayForSkinsBack() {
  console.log("skinsback支付", userStore.userInfo.steam_url);
  if (!userStore.userInfo.steam_url) {
    localStorage.setItem("keyword", true);
    close();
    eventEmitter.emit("nobind_SteamURL");
    return;
  }
  const params = {
    id: 1,
    pay_way: currencyDetail.value.pay_way, //充值方式
    coupon_code: (currencyDetail.value.promoCode || '').trim() || undefined,
    client_id: localStorage.getItem('ga4_client_id')
  };
  console.log("skinsback params;", params);
  $api.user.handleRecharge(params).then((res) => {
    console.log("skinsback res;", res);
    if (res.code != 200) {
      if(res.message !== 'Invalid coupon'){
        localStorage.setItem("keyword", true);
        close();
        eventEmitter.emit("nobind_SteamURL");
      }
      return showNotice("f", {desc: res.message});
    }

    // 后端返回 action 决定下一步
    const action = res.action || 'allow';
    if (action === 'reject') {
      riskRejectVisible.value = true;
      return;
    }
    if (action === 'payout_notice') {
      // A'：统一文案已包含 CS2 保护期说明，支付后不再弹旧的分账提示
      const url = res.list?.qr_url || '';
      if (url) {
        const winOpen = window.open("", "_blank");
        winOpen.location = url;
      }
      return;
    }
    // allow（vip 或风控不可用）→ 直接打开 Skinsback 支付页面
    let winOpen = window.open("", "_blank");
    const url = res.list.qr_url;
    winOpen.location = url;
  });
}

//溯源-返回虚拟货币列表
function trackSource() {
  currencyDetail.value.isShow = 0;
  currencyDetail.value.data = [];
  //清除定时器
  clearInterval(payTimer.value); //清除订单定时器
  clearInterval(indateTimer.value); //清除过期订单定时器
  //重置虚拟币处理对象
  resetcurrencyDetail(false);
  console.log("返回;", currencyDetail.value);
}

//关闭充值弹框
function close(e) {
  console.log("关闭充值弹框;", e);
  //清除定时器
  clearInterval(payTimer.value);
  clearInterval(indateTimer.value);
  //重置虚拟币处理对象
  resetcurrencyDetail();
  //关闭弹框
  emit("closed");
}

//银联充值处理
function handlePay() {
  // eventEmitter.emit("rechargePay");
  console.log("handlePay 银联充值处理");
  const result = Promise.resolve("充值成功");
  result
      .then((res) => {
        console.log("充值成功", res);
        emit("api:pay", res);
      })
      .catch((err) => {
        console.log("充值失败", err);
      });
  return result;
}

//是否显示加送角标 channel==kinguin && me接口 inviter_id=600013
const showAddSend = computed(() => {
  return (citem) => {
    return true;
    // if (citem.channel == "kinguin" && userStore.userInfo.inviter_id == 600013) {
    //   return true;
    // } else {
    //   return false;
    // }
  };
});

//获取支付列表
function getPaymentList() {
  return $api.user.getPaymentList({params: {client_type: "Pc"}});

  // .then((res) => {
  //   console.log("获取支付列表", res);
  //   res.data.forEach((item) => {
  //     payList.forEach((pay) => {
  //       if (pay.type === item.type) {
  //         for (let key in item) {
  //           if (key != "type") {
  //             pay[key] = item[key];
  //           }
  //         }
  //       }
  //     });
  //   });
  //   console.log("payList2;", payList);
  // });
}

//默认显示礼品卡
// getBeansList(activeCard.value.type);

// getPaymentList().then((res) => {
//   console.log("获取支付列表成功,默认显示卡密;", res);
//   //默认显示礼品卡
//   activeCard.value = { id: 1, type: "giftcard", beansList: [] };
//   getBeansList(activeCard.value.type);
// });

//数字货币1列表-如何实现动态导入图片模块
const digitalList1 = [
  {
    id: 1,
    name: "Bitcoin",
    alias: "BTC",
    currency: "btc",
    icon: getImageUrlByNewURL("recharge/digital1/1.png"),
  },
  {
    id: 2,
    name: "Ethereum",
    alias: "ERC20",
    currency: "eth",
    icon: getImageUrlByNewURL("recharge/digital1/2.png"),
  },
  {
    id: 3,
    name: "Tether US",
    alias: "ERC20",
    currency: "usdterc20",
    icon: getImageUrlByNewURL("recharge/digital1/3.png"),
  },
  {
    id: 4,
    name: "Tether US",
    alias: "TRC20",
    currency: "usdttrc20",
    icon: getImageUrlByNewURL("recharge/digital1/4.png"),
  },
  {
    id: 5,
    name: "USD Coin",
    alias: "USDC",
    currency: "usdc",
    icon: getImageUrlByNewURL("recharge/digital1/5.png"),
  },
  {
    id: 6,
    name: "Solana",
    alias: "SOL",
    currency: "sol",
    icon: getImageUrlByNewURL("recharge/digital1/6.png"),
  },
  {
    id: 7,
    name: "Ripple",
    alias: "XRP",
    currency: "xrp",
    icon: getImageUrlByNewURL("recharge/digital1/7.png"),
  },
  {
    id: 8,
    name: "Dogecoin",
    alias: "DOGE",
    currency: "doge",
    icon: getImageUrlByNewURL("recharge/digital1/8.png"),
  },
  {
    id: 9,
    name: "Tron",
    alias: "TRC20",
    currency: "trx",
    icon: getImageUrlByNewURL("recharge/digital1/9.png"),
  },
  {
    id: 10,
    name: "Litecoin",
    alias: "LTC",
    currency: "ltc",
    icon: getImageUrlByNewURL("recharge/digital1/10.png"),
  },
  {
    id: 11,
    name: "Bitcoin Cash Node",
    alias: "BTC",
    currency: "bch",
    icon: getImageUrlByNewURL("recharge/digital1/11.png"),
  },
  // {
  //   id: 12,
  //   name: "Other 130+ coins",
  //   alias: "",
  //   icon: getImageUrlByNewURL("recharge/digital1/12.png"),
  // },
];
const paymentList = ref([
  // {
  //   id: 1,
  //   name: "礼品卡",
  //   type: "giftcard",
  //   channel: "giftcard",
  //   // icon: "@/assets/images/recharge/payCard.png",
  //   icon: getImageUrlByNewURL("recharge/payCard.png"),
  // },
  // {
  //   id: 2,
  //   name: "皮肤充值-skinback",
  //   type: "skinsback",
  //   // icon: "@/assets/images/recharge/pskin.png",
  //   icon: getImageUrlByNewURL("recharge/pskin.png"),
  // },
  // // {
  // //   id: 3,
  // //   name: "数字货币1-whitepay",
  // //   type: "whitepay",
  // //   // icon: "@/assets/images/recharge/digital1.png",
  // //   icon: getImageUrlByNewURL("recharge/digital1.png"),
  // //   digitalList: digitalList1,
  // // },
  // {
  //   id: 4,
  //   name: "数字货币2-nowpayments",
  //   type: "nowpayments",
  //   // icon: "@/assets/images/recharge/digital2.png",
  //   icon: getImageUrlByNewURL("recharge/digital2.png"),
  // },
]);

if (props.visible) {
  eventEmitter.emit("ga4:purchase");
  console.log("===;", props.visible);
  getPaymentList().then((res) => {
    console.log("支付列表", res);
    const resp = handleResponse(res);
    if (!resp || resp.length == 0) {
      return;
    }
    let lang = localStorage.getItem('lang') || '';
    if(!lang) {
      lang = deviceStore.country.value
    }
    /**
     * pay_way=4[visa]支付方式为visa
     * pay_way=3[payCard]支付方式为卡密
     * pay_way=3和4,visa和卡密 都是小企鹅支付
     *
     * pay_way=2[skinpay]支付方式为皮肤充值-skinsback
     * pay_way=1[nowpay]支付方式为nowpayments
     *
     * 所有充值都送10%
     */
    if(lang.toUpperCase() === 'PL'){
      const excludedPayWays = [6, 8, 11, 19, 20, 21, 22, 23, 24, 25, 26, 27, 31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else if(lang.toUpperCase() === 'IDN' || lang.toUpperCase() === 'ID'){
      const excludedPayWays = [5, 6, 8, 11, 18, 20, 21, 22, 23, 24, 25, 26, 27, 31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else if(lang.toUpperCase() === 'RU'){
      const excludedPayWays = [5, 6, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else if(lang.toUpperCase() === 'BR'){
      const excludedPayWays = [5, 8, 11, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else if(lang.toUpperCase() === 'TH'){
      const excludedPayWays = [5, 6, 8, 11, 18, 19, 20, 21, 22, 23, 24, 25, 27, 31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else if(lang.toUpperCase() === 'ZH-CN' || lang.toUpperCase() === 'ZH-TW'){
      const excludedPayWays = [5, 6, 8, 11, 18];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else if(lang.toUpperCase() === 'FR' || lang.toUpperCase() === 'DE' || lang.toUpperCase() === 'ES' || lang.toUpperCase() === 'PT'){
      const excludedPayWays = [6, 8, 11, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else if(lang.toUpperCase() === 'JP' || lang.toUpperCase() === 'KR' || lang.toUpperCase() === 'TH'
        || lang.toUpperCase() === 'TR' || lang.toUpperCase() === 'VN'){
      const excludedPayWays = [5, 6, 8, 11, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    else{
      // paymentList.value.push(...res.data);
      const excludedPayWays = [31];
      res.data.forEach((item) => {
        if(!excludedPayWays.includes(item.pay_way)){
          paymentList.value.push(item);
        }
      })
    }
    // paymentList.value.push(...res.data);
    console.log("本地支付列表;", paymentList.value);
    paymentList.value.forEach((item) => {
      if (item.pay_way === 2) {
        //skinpay为skinback支付方式
        item.id = 2;
        if ('zh-CN' === locale.value) {
          item.icon = getImageUrlByNewURL("recharge/pskin_zh.png");
        } else {
          item.icon = getImageUrlByNewURL("recharge/pskin.png");
        }
        item.name = "皮肤充值-skinback";
        // item.type = "skinsback";
      }
      if (item.pay_way === 1) {
        //nowpay为nowpayments
        item.icon = getImageUrlByNewURL("recharge/digital_nowpayments.png");
        item.id = 1;
        item.name = "数字货币2-nowpayments";
        // item.type = "nowpayments";
        item.digitalList = digitalList1;
      }
      if (item.pay_way === 3) {
        //卡密
        item.icon = getImageUrlByNewURL("recharge/payCard.png");
        item.id = 3;
        item.name = "卡密充值";
      }
      if (item.pay_way === 4) {
        //卡密
        item.id = 4;
        if ('zh-CN' === locale.value) {
          item.icon = getImageUrlByNewURL("recharge/visa_zh.png");
        } else {
          item.icon = getImageUrlByNewURL("recharge/visa.png");
        }
        item.name = "visa";
      }
      if (item.pay_way === 5) {
        //gmpay  masterCard
        item.icon = getImageUrlByNewURL("recharge/GMPay.png");
        item.id = 5;
        item.name = "gmpayMas";
      }
      if (item.pay_way === 6) {
        //gmpay  pix
        item.icon = getImageUrlByNewURL("recharge/GMPayPix.png");
        item.id = 6;
        item.name = "gmpayPix";
      }
      if (item.pay_way === 7) {
        //gmpay  pix
        item.icon = getImageUrlByNewURL("recharge/GMPayshuzi.png");
        item.id = 7;
        item.name = "gmpayshuzi";
      }
      if (item.pay_way === 8) {
        //gmpay sbp c6n
        item.icon = getImageUrlByNewURL("recharge/GMPaySbp.png");
        item.id = 8;
        item.name = "gmpaySbp";
      }
      if (item.pay_way === 10) {
        //overpay visa
        item.id = 10;
        item.icon = getImageUrlByNewURL("recharge/overpay_visa.png");
        item.name = "overpay_sbp";
      }
      if (item.pay_way === 11) {
        //overpay sbp
        item.icon = getImageUrlByNewURL("recharge/overpay_sbp.png");
        item.id = 11;
        item.name = "overpay_visa";
      }
      if (item.pay_way === 12) {
        //paypal
        if ('zh-CN' === locale.value) {
          item.icon = getImageUrlByNewURL("recharge/visa_paypal_zh.png");
        } else {
          item.icon = getImageUrlByNewURL("recharge/visa_paypal.png");
        }
        item.id = 12;
        item.name = "paypal";
      }
      if (item.pay_way === 13) {
        //google pay
        if ('zh-CN' === locale.value) {
          item.icon = getImageUrlByNewURL("recharge/visa_googlepay_zh.png");
        } else {
          item.icon = getImageUrlByNewURL("recharge/visa_googlepay.png");
        }
        item.id = 13;
        item.name = "google_pay";
      }
      if (item.pay_way === 14) {
        //apple pay
        if ('zh-CN' === locale.value) {
          item.icon = getImageUrlByNewURL("recharge/visa_applepay_zh.png");
        } else {
          item.icon = getImageUrlByNewURL("recharge/visa_applepay.png");
        }
        item.id = 14;
        item.name = "apple_pay";
      }
      if (item.pay_way === 16) {
        //telegram
        item.id = 16;
        item.name = "telegram";
      }
    });

    console.log("支付列表;", paymentList.value);

    activeCard.value = paymentList.value[0];
    if (1) {
      currencyDetail.value.pay_way = activeCard.value.pay_way; //res.data[0]为nowpay;res.data[1]为skinpay
      console.log("kk;", activeCard.value);
      getBeansList(activeCard.value.channel);
      // 如果默认选中的是 skinpay，提前获取风控等级
      if (activeCard.value.type === "skin") {
        $api.user.riskStatus().then((res) => {
          if (res && res.code === 200 && res.data) {
            skinpayRiskLevel.value = res.data.skinpay_level || res.data.risk_level || 'vip';
          }
        }).catch(() => {
          skinpayRiskLevel.value = 'vip';
        });
      }
    }
  });
}

/**
 * 移动nowpayments支付到数组最后
 */
function moveNowPaymentToEnd(array) {
  //过滤出channel为nowpay的对象
  const nowpayItems = array.filter((item) => item.channel === "nowpay");
  //过滤出channel不为nowpay的对象
  const otherItems = array.filter((item) => item.channel !== "nowpay");
  //将nowpay对象移动到数组最后
  return [...otherItems, ...nowpayItems];
}

// 移动nowpayments支付到数组最后
const payList = [
  {
    id: 1,
    name: "支付宝",
    type: "alipay",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 2,
    name: "微信",
    type: "wechat",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 3,
    name: "银行卡",
    type: "bank",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 4,
    name: "礼品卡-卡密",
    type: "giftcard",
    // type: "currency",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 5,
    name: "PayPal",
    type: "paypal",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 6,
    name: "Apple Pay",
    type: "applepay",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 7,
    name: "Google Pay",
    type: "googlepay",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 8,
    name: "Venmo",
    type: "venmo",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 9,
    name: "Payoneer",
    type: "payoneer",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 10,
    name: "Bitcoin",
    type: "bitcoin",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 11,
    name: "skrill",
    type: "skrill",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 12,
    name: "虚拟货币",
    type: "currency",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 13,
    name: "Payeer",
    type: "payeer",
    icon: "@/assets/images/recharge/pay1.png",
  },
  {
    id: 14,
    name: "Qiwi",
    type: "qiwi",
    icon: "@/assets/images/recharge/pay1.png",
  },
];

// ========== 风控相关 ==========
const riskConfirmVisible = ref(false);     // 邮件确认弹窗
const riskRejectVisible = ref(false);      // 拒绝弹窗
const riskPayoutVisible = ref(false);      // 到账方式提示弹窗
const riskPayoutLevel = ref('normal');     // 当前用户风险等级
const skinpayRiskLevel = ref('vip');       // skinpay 风控等级
const payoutCountdown = ref(15);           // 弹窗自动关闭倒计时
const payoutTimer = ref(null);             // 倒计时定时器
let riskPaymentUrl = '';                   // 风控通过后待打开的支付链接（方案A）
const riskEmail = ref('');                 // 用户输入的邮箱
const riskEmailError = ref('');            // 邮箱验证错误信息
const riskSending = ref(false);            // 发送中
const riskEmailSent = ref(false);          // 邮件已发送
const riskCountdown = ref(300);            // 倒计时（秒）
const riskOrderNo = ref('');               // 当前风控订单号
const riskCardItem = ref(null);            // 暂存充值档位信息
const riskCardFirst = ref('');             // 卡号前6位
const riskCardLast = ref('');              // 卡号后4位
const riskCardError = ref('');             // 卡号验证错误
const riskCardHolder = ref('');            // 持卡人姓名
const riskHolderError = ref('');           // 持卡人姓名验证错误
const riskTimer = ref(null);               // 轮询定时器
const riskCountTimer = ref(null);          // 倒计时定时器

// 邮箱正则
function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// 关闭风控确认弹窗
function closeRiskConfirm() {
  riskConfirmVisible.value = false;
  riskEmail.value = '';
  riskEmailError.value = '';
  riskEmailSent.value = false;
  riskSending.value = false;
  riskCountdown.value = 300;
  riskCardFirst.value = '';
  riskCardLast.value = '';
  riskCardError.value = '';
  riskCardHolder.value = '';
  riskHolderError.value = '';
  clearInterval(riskTimer.value);
  clearInterval(riskCountTimer.value);
}

// 是否为银行卡支付
const isCardPayment = computed(() => {
  const channel = activeCard.value?.channel || '';
  // glodrapay/visa/master 渠道为银行卡支付
  return ['glodrapay', 'visa', 'master'].includes(channel);
});

// 关闭风控到账弹窗（清理定时器）
function closeRiskPayout() {
  riskPayoutVisible.value = false;
  if (payoutTimer.value) {
    clearInterval(payoutTimer.value);
    payoutTimer.value = null;
  }
}

// 确认到账方式 → 关闭弹窗（支付链接已在弹窗弹出时打开）
function confirmPayout() {
  closeRiskPayout();
}

// 发送风控确认邮件
function sendRiskConfirmation() {
  // Email 验证
  if (!riskEmail.value) {
    riskEmailError.value = $t('riskEmailRequired');
    return;
  }
  if (!isValidEmail(riskEmail.value)) {
    riskEmailError.value = $t('riskEmailInvalid');
    return;
  }
  riskEmailError.value = '';

  // 银行卡支付时验证卡号和持卡人
  if (isCardPayment.value) {
    // 卡号前6位
    if (!riskCardFirst.value || !/^\d{6}$/.test(riskCardFirst.value)) {
      riskCardError.value = 'Please enter 6 digits';
      return;
    }
    // 卡号后4位
    if (!riskCardLast.value || !/^\d{4}$/.test(riskCardLast.value)) {
      riskCardError.value = 'Please enter 4 digits';
      return;
    }
    riskCardError.value = '';

    // 持卡人姓名不能为空（至少2个字符）
    if (!riskCardHolder.value || riskCardHolder.value.trim().length < 2) {
      riskHolderError.value = 'Please enter cardholder name';
      return;
    }
    riskHolderError.value = '';
  }

  riskSending.value = true;

  console.log('[risk] sendConfirmation', {
    order_no: riskOrderNo.value,
    riskPaymentUrl: riskPaymentUrl,
    riskPaymentUrl_type: typeof riskPaymentUrl,
    riskPaymentUrl_len: riskPaymentUrl?.length || 0,
  });

  // WAF 可能过滤含 http 的字段值，改用 base64 编码绕过
  const encodedPayUrl = riskPaymentUrl ? btoa(riskPaymentUrl) : '';
  console.log('[risk] encodedPayUrl:', encodedPayUrl);

  $api.user.sendConfirmation({
    user_id: userStore.userInfo.id,
    order_no: riskOrderNo.value,
    email: riskEmail.value,
    amount: riskCardItem.value?.price || 0,
    pay_url: riskPaymentUrl || '__EMPTY__',
    purl: riskPaymentUrl || '__EMPTY__',
    encoded_pay: encodedPayUrl,
    // 银行卡支付时附加卡号信息
    card_first6: riskCardFirst.value || undefined,
    card_last4: riskCardLast.value || undefined,
    card_holder: riskCardHolder.value || undefined,
  }).then((res) => {
    riskSending.value = false;
    if (res.code === 200) {
      riskEmailSent.value = true;
      riskCountdown.value = 300;
      // 开始倒计时
      riskCountTimer.value = setInterval(() => {
        riskCountdown.value--;
        if (riskCountdown.value <= 0) {
          clearInterval(riskCountTimer.value);
          closeRiskConfirm();
          showNotice('f', { desc: $t('riskTimeout') });
        }
      }, 1000);
      // 开始轮询确认状态
      pollConfirmationStatus();
    } else {
      showNotice('f', { desc: res.message || $t('riskSendFail') });
    }
  }).catch(() => {
    riskSending.value = false;
    showNotice('f', { desc: $t('riskSendFail') });
  });
}

// 轮询邮件确认状态
let pollHandled = false;
function pollConfirmationStatus() {
  // 清除旧定时器，防止多个 interval 同时跑
  if (riskTimer.value) {
    clearInterval(riskTimer.value);
    riskTimer.value = null;
  }
  pollHandled = false;
  riskTimer.value = setInterval(() => {
    // 弹窗已关闭，停止轮询
    if (!riskConfirmVisible.value) {
      clearInterval(riskTimer.value);
      riskTimer.value = null;
      return;
    }
    // 防止并发请求重复处理
    if (pollHandled) return;
    $api.user.checkConfirmationStatus(riskOrderNo.value, { showLoading: false }).then((res) => {
      if (res.code === 200 && res.data?.status === 'confirmed') {
        pollHandled = true;
        clearInterval(riskTimer.value);
        clearInterval(riskCountTimer.value);
        riskTimer.value = null;
        riskCountTimer.value = null;
        closeRiskConfirm();
        showNotice('s', { desc: $t('riskConfirmed') });
      }
    }).catch(() => {});
  }, 3000);
}

// 风控开关在后端控制，前端只管调接口、按结果执行
function riskCheckBeforePay(cardItem, orderNo) {
  return new Promise((resolve, reject) => {
    // 未登录不风控
    if (!userStore.userInfo?.id) {
      return resolve({ decision: 'allow' });
    }

    $api.user.riskCheck({
      user_id: userStore.userInfo.id,
      amount: cardItem.price || 0,
      order_no: orderNo || '', // 使用真实充值订单号
    }).then((res) => {
      if (res.code === 200) {
        const decision = res.data?.decision || 'allow';
        if (decision === 'allow') {
          resolve({ decision: 'allow' });
        } else if (decision === 'challenge') {
          riskOrderNo.value = orderNo || res.data?.order_no || '';
          riskCardItem.value = cardItem;
          riskConfirmVisible.value = true;
          resolve({ decision: 'challenge' });
        } else {
          // reject
          riskRejectVisible.value = true;
          resolve({ decision: 'reject' });
        }
      } else {
        // 风控接口异常，默认允许
        resolve({ decision: 'allow' });
      }
    }).catch(() => {
      // 网络异常，默认允许
      resolve({ decision: 'allow' });
    });
  });
}

// 充值结果弹框
const resultVisible = ref(false);

function closeResult() {
  // return;
  resultVisible.value = false;
}

const resultBtnTxt = ref("OK"); //TRY AGAIN
const resultInfo = ref("payResultSuccessInfo");
const resultImg = ref(getImageUrlByNewURL("systemicon/notice_success.png"));
const payResult = ref(true); //支付结果
console.log("充值组件");
setTimeout(() => {
  // payResult.value = false;
  // resultVisible.value = true;
}, 2000);
watch(
    () => payResult.value,
    () => {
      if (payResult.value) {
        resultBtnTxt.value = "OK";
        resultInfo.value = "payResultSuccessInfo";
        resultImg.value = getImageUrlByNewURL("systemicon/notice_success.png");
      } else {
        resultBtnTxt.value = "TRY AGAIN";
        resultInfo.value = "payResultFailInfo";
        resultImg.value = getImageUrlByNewURL("systemicon/notice_error.png");
      }
    }
);

//谷歌埋点-点击按钮支付
// const trackRecharge = () => {
//   // 发送 begin_checkout 事件
//   gtag.event('begin_checkout', {
//     currency: 'USD',
//     value: 99.99,
//     items: [{
//       item_id: 'annual_vip',
//       item_name: '年度VIP会员'
//     }]
//   })
//
//   // 实际充值逻辑
//   processPayment()
// }

//支付成功页面google埋点
// onMounted(() => {
//   // 从路由参数获取订单信息
//   const orderData = {
//     transaction_id: route.query.order_id,
//     value: parseFloat(route.query.amount),
//     currency: 'USD',
//     items: JSON.parse(decodeURIComponent(route.query.items))
//   }
//
//   // 发送购买事件
//   gtag.event('purchase', orderData)
// })

function toBank() {
  console.log('go to bank')
  close();
  router.push({name: "bank"});
}

</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0.03rem;
  // background: #1B2132;
  // background-color: yellow;
}

::-webkit-scrollbar-thumb {
  width: 0.03rem;
  border-radius: 0.3125rem;
  background: $active-color;
}

.active-card {
  @extend %clearBgi;
  // background-size: 100% 100%;
  background-image: url("@/assets/images/recharge/selected.png");

  .card {
    border: none !important;
  }
}

.promocode {
  // border: 2px solid red;
  height: 1.5rem;
  background-color: #161c2a;
  border-radius: 0.1rem;
  margin-bottom: 0.2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;

  .title {
    // border: 2px solid yellow;
    font-size: 0.2rem;
    font-weight: bold;
    color: #a3b2cf;
  }

  .col {
    width: 100%;
    // border: 2px solid red;
  }

  .input-container {
    margin-top: 0.19rem;
    height: 0.4rem;
    @extend %flex-all-center;

    .ant-input {
      width: 6.87rem;
      margin-right: 0.3rem;
    }

    .ant-btn {
      min-width: 1rem;
      height: 0.4rem;
      border-radius: 0.2rem;
      // background-color: #443439;
      color: #ffffff;
      font-size: 0.14rem;
      font-weight: bold;
      @extend %flex-all-center;
    }

    .disable-btn {
      background-color: #443439;
    }

    .able-btn {
      background-color: $active-color;

      &:hover {
        background-color: #eb336b;
      }
    }
  }
}

// 银联
.bank-container {
  // border: 2px solid red;
  .email,
  .amountleft,
  .amountright,
  .promocode {
    width: inherit;
    background-color: #161c2a;
  }

  .email {
    height: 1.5rem;
    padding: 0 0.5rem;

    .input-container {
      margin-top: 0.24rem;
      display: flex;

      .ant-input {
        width: 6.8rem;
      }

      .ant-btn {
        width: 1rem;
        height: 0.4rem;
        background-color: $active-color;
        border-radius: 0.2rem;
        font-size: 0.14rem;
        font-weight: bold;
      }
    }
  }

  .amount {
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    height: 2.6rem;
    display: flex;
    justify-content: space-between;

    .amountleft,
    .amountright {
      width: 4rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-evenly;
    }

    .amountleft {
      padding: 0 0.5rem;
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      // justify-content: space-evenly;
      .acol {
        width: 100%;
      }

      .price-list {
        display: flex;

        justify-content: space-evenly;

        .ant-btn {
          width: 0.6rem;
          height: 0.3rem;
          border-radius: 0.15rem;
          background-color: #202737;
          @extend %flex-all-center;
        }
      }
    }

    .amountright {
      .pay-btn {
        .ant-btn {
          width: 1.7rem;
          height: 0.46rem;
          border-radius: 0.23rem;
          @extend %flex-all-center;
          background-color: $active-color;
          color: #ffffff;
          font-size: 0.2rem;
          font-weight: bold;
        }
      }
    }
  }

  .promocode {
    // height: 1.5rem;
  }
}

//虚拟货币
.virtual-container {
  height: 6.8rem;
  overflow-y: scroll;

  .telegram-container {
    display: flex;
    align-items: center;

    .content-grid {
      display: grid;
      grid-template-columns: 1fr;
      gap: 0.25rem;
      width: 100%;

      @media (min-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        gap: 0.313rem;
      }
    }

    .method-card {
      background: rgba(30, 41, 59, 0.5);
      backdrop-filter: blur(12px);
      border-radius: 0.25rem;
      padding: 0 0.375rem;
      border: 1px solid rgba(51, 65, 85, 0.5);
      box-shadow: 0 5px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 2px -1px rgba(0, 0, 0, 0.04);
    }

    .method-badge {
      display: inline-block;
      background: #e60046;
      color: white;
      padding: 0.094rem 0.219rem;
      border-radius: 0.125rem;
      font-weight: 600;
      font-size: 17px;
      margin-top: -0.08rem;
      margin-bottom: 0.25rem;
    }

    .method-title {
      color: #cbd5e1;
      text-align: center;
      font-size: 18px;
      margin-bottom: 0.2rem;
      line-height: 1.3;

      &.method-title-spaced {
        margin-bottom: 0.5rem;
      }
    }

    .qr-wrapper {
      display: flex;
      justify-content: center;
      margin-bottom: 0.15rem;
    }

    .qr-container {
      background: white;
      padding: 0.15rem;
      border-radius: 0.156rem;
    }

    .qr-image {
      width: 150px;
      height: 150px;
      display: block;
    }

    .price-info {
      text-align: center;
      margin-bottom: 0.15rem;
    }

    .price-usd {
      color: #34d399;
      font-size: 26px;
      font-weight: 700;
    }

    .price-separator {
      color: #34d399;
      margin: 0 0.125rem;
      font-size: 26px;
    }

    .price-stars {
      color: #fbbf24;
      font-size: 26px;
      img {
        width: 20px;
        height: 20px;
        transform: translateY(-10%);
      }
    }

    .button-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 50px;
    }

    .telegram-button {
      position: relative;
      overflow: hidden;
      background: linear-gradient(to right, #db2777, #e60046);
      color: white;
      font-weight: 700;
      padding: 0.119rem 0.625rem;
      border-radius: 9999px;
      font-size: 20px;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 2px 3px -1px rgba(0, 0, 0, 0.1), 0 1px 1px 0 rgba(0, 0, 0, 0.05);

      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0;
        height: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.1);
        transform: translate(-50%, -50%);
        transition: width 0.6s, height 0.6s;
      }

      &:hover {
        background: linear-gradient(to right, #be185d, #e60046);
        transform: scale(1.05);
        box-shadow: 0 0 8px rgba(236, 72, 153, 0.5);

        &::before {
          width: 75px;
          height: 75px;
        }
      }

      &:active {
        transform: scale(0.95);
      }
    }

    .notice-text {
      color: #64748b;
      font-size: 14px;
      margin-top: 0.313rem;
      text-align: center;
    }
  }
  // .title {
  //   // border: 2px solid yellow;
  //   font-size: 0.2rem;
  //   font-weight: 400;
  //   color: #ffffff;
  // }

  // .gift-list {
  //   border: 2px solid red;
  //   background-color: #161c2a;
  //   padding: 0.4rem 0.3rem;
  //   margin-top: 0.3rem;
  //   margin-bottom: 0.4rem;
  //   display: grid;
  //   grid-template-columns: repeat(6, 1.2rem);
  //   row-gap: 0.2rem;
  //   column-gap: 0.2rem;
  //   .gift {
  //     width: 1.2rem;
  //     height: 0.6rem;
  //     border-radius: 0.3rem;
  //     cursor: pointer;
  //     background-color: #202737;
  //     @extend %flex-all-center;
  //     &:before {
  //       content: "$";
  //     }
  //     font-size: 0.2rem;
  //     font-weight: bold;
  //     color: #ffffff;
  //     &:hover {
  //       @extend .active-gift;
  //     }
  //   }
  //   .active-gift {
  //     border: 1px solid #1ffbce;
  //     background: #0e2722;
  //   }
  // }
  .gift-list {
    // border: 2px solid red;
    // background-color: #161c2a;
    // padding: 0.4rem 0.3rem;
    margin-top: 0.03rem;
    margin-left: 0.03rem;

    margin-bottom: 0.4rem;
    display: grid;
    grid-template-columns: repeat(5, 1.74rem);
    row-gap: 0.1rem;
    column-gap: 0.1rem;

    .gift {
      width: 1.74rem;
      height: 1.96rem;
      border-radius: 0.1rem;
      position: relative;
      cursor: pointer;
      background-color: #202737;
      @extend %flex-all-center;
      // &:before {
      //   content: "$";
      //   position: absolute;
      //   left: .13rem;
      //   top: .16rem;
      // }
      font-weight: bold;
      font-size: 0.42rem;
      color: #ffffff;

      img {
        width: inherit;
      }

      &:hover {
        @extend .active-gift;
        transform: scale(1.02);
        transition: all 0.1s ease-in-out;
      }

      .nowpay-price {
        padding: 0;
        position: absolute;
        left: 0.13rem;
        top: 0.16rem;
        line-height: 0.24rem;
      }

      .gmpay-price {
        padding: 0;
        line-height: 0.3rem;
        position: absolute;
        top: 0.4rem;
        right: 0.09rem;
        font-size: 0.4rem;
        font-weight: bold;
        color: #ffffff;
      }
    }

    .active-gift {
      // border: 1px solid #1ffbce;
      // background: #0e2722;
    }
  }

  .title-info {
    font-weight: 400;
    font-size: 0.16rem;
    color: #a3b2cf;
  }

  .v-coins {
    margin-top: 0.3rem;
    display: grid;
    grid-template-columns: repeat(5, 1.74rem);
    grid-gap: 0.08rem;
    height: 5.6rem;

    .v-coin {
      cursor: pointer;
      width: 1.74rem;
      height: 1.8rem;
      border-radius: 0.1rem;
      background-color: #161c2a;
      @extend %flex-all-center;
      flex-direction: column;

      .v-img {
        width: 0.66rem;
        height: 0.42rem;
        margin-bottom: 0.3rem;

        img {
          width: 0.66rem;
        }
      }

      .v-name {
        font-size: 0.16rem;
        font-weight: 400;
        color: #dcdefc;
      }

      .v-alias {
        font-size: 0.14rem;
        font-weight: 400;
        color: #7d93c4;
      }
    }
  }

  .promocode {
    margin-top: 0.2rem;
    background-color: #161c2a;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    border-radius: 0.1rem;
    // height: 1.5rem;
    // .title {
    //   font-weight: bold;
    //   font-size: 20px;
    //   color: #a3b2cf;
    // }
  }

  // 虚心币详情
  .coin-container {
    display: flex;
    padding: 0.33rem 0.4rem;
    .back {
      cursor: pointer;
      font-size: 0.2rem;
      width: 1.3rem;
      height: 0.44rem;
      border-radius: 0.05rem;
      background-color: #272d40;
      @extend %flex-all-center;
    }

    .coin-left {
      margin-right: 0.4rem;
      width: 2.8rem;

      .qrcode {
        width: 2rem;
        height: 2rem;
        border-radius: 0.1rem;
        background-color: #ffffff;
        margin-top: 0.95rem;
        @extend %flex-all-center;

        img {
          width: 1.92rem;
          height: 1.92rem;
        }
      }

      //虚拟充值提示
      .pay-info {
        font-size: 0.14rem;
        font-weight: bold;
        color: #a3b2cf;
        margin: 0.18rem 0 0.1rem 0;

        .error {
          &::before {
            content: "*";
          }

          &::after {
            content: ":";
          }

          color: $active-color;
        }
      }

      .require-info {
        width: 2rem;
        height: 0.46rem;
        border-radius: 0.23rem;
        color: #ffc600;
        font-size: 0.18rem;
        font-weight: bold;
        background-color: #1e2637;
        @extend %flex-all-center;
      }
    }

    .coin-right {
      .title {
        padding-left: 0.78rem;
        display: flex;
        align-items: center;

        img {
          width: 0.58rem;
          margin-right: 0.23rem;
        }

        span.coin-name {
          font-size: 0.32rem;
          font-weight: bold;
          color: #dcdefc;
        }
      }

      .content {
        margin-top: 0.5rem;

        .t1 {
          font-size: 0.21rem;
          font-weight: bold;
          color: #dcdefc;
        }

        .code-link {
          margin-top: 0.21rem;
          padding-left: 0.31rem;
          display: flex;
          align-items: center;
          background-color: #1e2637;
          border-radius: 0.1rem;
          height: 0.46rem;
          position: relative;
          font-size: 0.18rem;

          .copy-icon {
            right: 0.24rem;
            width: 0.14rem;
            position: absolute;
          }

          .gspan {
            color: #37e629;
            font-size: 0.18rem;
          }
        }

        .info {
          font-size: 0.14rem;
          font-weight: 400;
          color: #a3b2cf;
          display: flex;
          align-items: center;
          margin-top: 0.2rem;
          margin-bottom: 0.31rem;

          img {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.1rem;
          }
        }

        .title2 {
          font-weight: 400;
          font-size: 0.18rem;
          color: #dcdefc;
        }

        .message {
          margin-top: 0.32rem;

          .m1 {
            font-weight: 400;
            font-size: 0.18rem;
            color: #dcdefc;
            display: flex;
            align-items: center;

            img {
              width: 0.16rem;
              height: 0.16rem;
              margin-right: 0.1rem;
            }
          }

          .mt {
            font-weight: 400;
            font-size: 0.14rem;
            color: #a3b2cf;
            line-height: 0.18rem;
            margin-top: 0.27rem;

            .note {
              color: $active-color;
              font-weight: bold;

              &::before {
                content: "*";
              }

              &::after {
                content: ":";
              }
            }
          }
        }
      }
    }
  }
}

//礼品卡
.gift-container {
  // border: 2px solid blue;
  height: 6.7rem;

  .gift-list {
    display: grid;
    grid-template-columns: repeat(5, 1.74rem);
    row-gap: 0.18rem;
    column-gap: 0.1rem;

    .gift {
      width: 1.74rem;
      height: 1.96rem;
      position: relative;

      &:hover {
        cursor: pointer;
        transform: scale(1.05);
        transition: all 0.1s ease-in-out;
      }

      img {
        width: inherit;
      }

      .gift-price {
        &::before {
          content: "$";
        }

        padding: 0;
        line-height: 0.3rem;
        position: absolute;
        top: 0.4rem;
        right: 0.09rem;
        font-size: 0.4rem;
        font-weight: bold;
        color: #ffffff;
      }
    }
  }

  .gift-info {
    font-weight: 400;
    font-size: 0.16rem;
    color: #a3b2cf;
    margin: 0.3rem 0;
  }
}

//skrill
.skinsback-container {
  // border: 2px solid orange;
  height: auto;
  min-height: 6.7rem;

  .block {
    // border: 2px solid green;
    height: auto;
    min-height: 3.8rem;
    background-color: #161c2a;
    border-radius: 0.1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.2rem;
    padding: 0.2rem 0;

    .info {
      margin-bottom: 0.4rem;
      font-size: 0.24rem;
      font-weight: bold;
    }

    .promo-banner {
      width: 7.7rem;
      margin-bottom: 0.2rem;
      border-radius: 0.1rem;
      overflow: hidden;

      .banner-bg {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    //.tips{
    //  font-weight: 400;
    //  font-size: .14rem;
    //  color: #515868;
    //  transform: translateY(-0.4rem);
    //}

    .tip-bar {
      width: 7.7rem;
      height: auto;
      min-height: .5rem;
      padding: .1rem .14rem;
      background: rgba(204, 162, 95, 0.2);
      border-radius: .1rem;
      border: 1px solid #6B5840;
      margin-bottom: .2rem;
      font-weight: 400;
      font-size: .14rem;
      color: #DDAC58;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      line-height: 1.35;
      box-sizing: border-box;

      .tip-content {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: .04rem;
      }

      .tip-content span {
        display: block;
        flex: none;
        min-width: 0;
        word-break: break-word;
        white-space: normal;
        text-align: left;
      }

      .tip-rust-dota {
        margin-top: 0;
      }

      img {
        width: .2rem;
        height: .2rem;
        margin: 0 .12rem;
        flex: 0 0 .2rem;
        margin-top: .02rem;
      }

      .normal-txt {

      }

      .link-txt {
        margin-left: .52rem;
        font-size: .14rem;
        color: #DDDB58;
        line-height: .18rem;
        text-decoration-line: underline;
        cursor: pointer;
      }
    }

    .btn {
      margin-top: .24rem;

      .ant-btn {
        min-width: 1.7rem;
        width: max-content;
        height: 0.46rem;
        background-color: $active-color;
        //background: #443439;
        //color: #624E4E;
        border-radius: 0.23rem;
        font-size: 0.2rem;
        font-weight: bold;
      }
    }
  }
}

.recharge-dialog {
  // border: 1px solid red;

  .recharge-modal {
    :deep(.ant-modal) {
      // border: 2px solid yellow;
      width: 17rem;
      height: 8.2rem;
      background-color: #0e121e;
      // background-color: #ed51af;
      .ant-modal-content {
        background-color: #0e121e;
        height: inherit;
      }

      .ant-modal-close {
        right: 0.4rem;
        top: 0.4rem;

        img {
          width: 0.16rem;
          // height: .16rem;
        }
      }

      .ant-modal-body {
        padding: 1rem 0.7rem 0 0.7rem;
        height: inherit;
        display: flex;
        // background-color: #0e121e;
        // border: 2px solid skyblue;
      }

      .recharge-container {
        display: flex;
        // border: 2px solid blue;
        .left,
        .right {
          // border: 2px solid green;
        }
        .right {
          .back {
            cursor: pointer;
            font-size: 0.2rem;
            width: 1.3rem;
            height: 0.44rem;
            border-radius: 0.05rem;
            background-color: #272d40;
            transform: translate(10%,-70%);
            @extend %flex-all-center;
          }
        }
        .left {
          width: 6.2rem;

          .title {
            @extend %flex-all-center;
            justify-self: flex-start;

            .picon {
              width: 0.36rem;
              height: 0.36rem;
              margin-right: 0.26rem;
            }

            span {
              font-weight: bold;
              font-size: 0.24rem;
              color: #ffffff;
            }
          }

          .line {
            height: 0.01rem;
            margin-top: 0.28rem;
            margin-bottom: 0.3rem;
            background-color: #272d40;
          }

          .list-container {
            .list-title {
              font-weight: 400;
              font-size: 0.18rem;
              color: #687088;
              margin-bottom: 0.2rem;
            }

            .list-cards {
              //border: 2px solid red;
              overflow-y: scroll;
              overflow-x: hidden;
              max-height: 4.6rem;
              display: grid;
              grid-template-columns: repeat(3, 1.98rem);
              grid-gap: 0.1rem;

              .card-item {
                // border: 2px solid yellow;
              }

              .card {
                height: 1.3rem;
                border: 1px solid #304b75;
                border-radius: 0.05rem;
                @extend %flex-all-center;
                position: relative;

                .addsend {
                  width: 0.98rem;
                  position: absolute;
                  top: 0;
                  right: 0;
                }

                .card-icon {
                  // border: 2px solid red;
                  width: 2rem;
                  height: 1.3rem;
                }

                &:hover {
                  cursor: pointer;
                  border: none;
                  @extend .active-card;
                }
              }
            }
          }
        }

        .right {
          // width: 9.1rem;
          width: 9.2rem;
          height: 6rem;
          margin-left: 0.3rem;
        }
      }
    }
  }
}

//充值结果弹框
.recharge-result-modal {
  :deep(.ant-modal) {
    width: 4.96rem !important;
    height: 2.9rem;
    top: 20%;
    background-color: #0e121e;

    .ant-modal-close-x {
      position: absolute;
      top: 0.14rem;
      right: 0.1rem;
      // img {
      //   width: 0.4rem;
      //   height: 0.4rem;
      // }
    }

    .ant-modal-body {
      height: 2.9rem;
      @extend %flex-all-center;
      flex-direction: column;

      .tips {
        color: #ffffff;
        font-size: 0.24rem;
        font-weight: bold;
        margin-bottom: 0.5rem;
      }

      .content {
        width: 100%;
        @extend %flex-all-center;
        flex-direction: column;

        .info {
          @extend %flex-all-center;
          font-size: 0.17rem;
          font-weight: 400;
          color: #a3b2cf;

          .infos {
            width: max-content;
            max-width: 3.1rem;
          }

          img {
            width: 0.4rem;
            margin-right: 0.1rem;
          }
        }

        .result-btn {
          &:hover {
            background-color: #eb336b;
          }

          margin-top: 0.31rem;
          width: 1.7rem;
          height: 0.46rem;
          border-radius: 0.23rem;
          background-color: $active-color;
          font-size: 0.2rem;
          font-weight: bold;
        }
      }
    }
  }
}

// 风控邮件确认弹框
.risk-confirm-modal {
  :deep(.ant-modal) {
    width: 5.5rem !important;
    background-color: #0e121e;

    .ant-modal-close {
      right: 0.4rem;
      top: 0.4rem;
      img { width: 0.16rem; }
    }

    .ant-modal-body {
      padding: 0.5rem;

      .risk-confirm-body {
        .risk-title {
          font-size: 0.24rem;
          font-weight: bold;
          color: #ffc600;
          margin-bottom: 0.15rem;
          text-align: center;
        }

        .risk-desc {
          font-size: 0.14rem;
          color: #a3b2cf;
          margin-bottom: 0.25rem;
          text-align: center;
          line-height: 1.5;
        }

        .risk-field {
          margin-bottom: 0.2rem;

          .risk-field-title {
            font-size: 0.16rem;
            font-weight: 600;
            color: #687088;
            margin-bottom: 0.1rem;
          }

          .risk-input-wrapper {
            .ant-input {
              width: 100%;
              height: 0.45rem;
              background-color: #161c2a;
              border: 1px solid #304b75;
              border-radius: 0.08rem;
              color: #ffffff;
              font-size: 0.16rem;
              padding: 0 0.15rem;

              &:focus {
                border-color: $active-color;
              }
            }
          }
        }

        .risk-field-error {
          font-size: 0.12rem;
          color: #ff4d4f;
          margin-top: 0.06rem;
          margin-bottom: 0.05rem;
        }

        .risk-card-number {
          display: flex;
          align-items: center;
          gap: 0.08rem;

          .risk-card-segment {
            flex: 1;

            .ant-input {
              width: 100%;
              height: 0.45rem;
              background-color: #161c2a;
              border: 1px solid #304b75;
              border-radius: 0.08rem;
              color: #ffffff;
              font-size: 0.16rem;
              padding: 0 0.15rem;
              text-align: center;
              letter-spacing: 0.1rem;

              &:focus {
                border-color: $active-color;
              }
            }
          }

          .risk-card-dots {
            font-size: 0.18rem;
            color: #687088;
            letter-spacing: 0.05rem;
            flex-shrink: 0;
          }
        }

        .risk-btns {
          display: flex;
          justify-content: center;
          gap: 0.15rem;
          margin-top: 0.15rem;

          .risk-send-btn {
            min-width: 0.8rem;
            padding: 0 0.3rem;
            height: 0.45rem;
            border-radius: 0.22rem;
            font-size: 0.16rem;
            font-weight: bold;
            white-space: nowrap;
          }

          .risk-send-btn {
            background-color: $active-color;
            color: #ffffff;
            border: none;

            &:hover {
              background-color: #eb336b;
            }
          }
        }

        .risk-waiting {
          margin-top: 0.2rem;
          text-align: center;
          padding: 0.15rem;
          background-color: rgba(255, 198, 0, 0.1);
          border-radius: 0.08rem;
          border: 1px solid rgba(255, 198, 0, 0.3);

          .risk-waiting-text {
            font-size: 0.13rem;
            color: #ffc600;
            margin-bottom: 0.08rem;
          }

          .risk-timer {
            font-size: 0.2rem;
            font-weight: bold;
            color: #ffc600;
          }
        }
      }
    }
  }
}

// 风控拒绝弹框
.risk-reject-modal {
  :deep(.ant-modal) {
    width: 4.5rem !important;
    background-color: #0e121e;

    .ant-modal-close {
      right: 0.3rem;
      top: 0.3rem;
      img { width: 0.14rem; }
    }

    .ant-modal-body {
      padding: 0.6rem 0.5rem;

      .risk-reject-body {
        text-align: center;

        .risk-reject-icon {
          font-size: 0.6rem;
          margin-bottom: 0.15rem;
        }

        .risk-reject-title {
          font-size: 0.22rem;
          font-weight: bold;
          color: #ff4444;
          margin-bottom: 0.15rem;
        }

        .risk-reject-desc {
          font-size: 0.14rem;
          color: #a3b2cf;
          line-height: 1.5;
          margin-bottom: 0.25rem;
        }

        .risk-reject-btn {
          width: 1.5rem;
          height: 0.4rem;
          border-radius: 0.2rem;
          background-color: $active-color;
          color: #ffffff;
          font-size: 0.16rem;
          font-weight: bold;
          border: none;

          &:hover {
            background-color: #eb336b;
          }
        }
      }
    }
  }
}

// 风控到账方式提示弹窗
.risk-payout-modal {
  :deep(.ant-modal) {
    width: 5rem !important;
    background-color: #0e121e;

    .ant-modal-close {
      right: 0.4rem;
      top: 0.4rem;
      img { width: 0.16rem; }
    }

    .ant-modal-body {
      padding: 0.5rem;

      .risk-payout-body {
        .risk-title {
          font-size: 0.24rem;
          font-weight: bold;
          color: #ffc600;
          margin-bottom: 0.15rem;
          text-align: center;
        }

        .risk-desc {
          font-size: 0.16rem;
          color: #a3b2cf;
          margin-bottom: 0.25rem;
          text-align: center;
          line-height: 1.5;
          font-weight: 500;
        }

        .risk-btns {
          display: flex;
          justify-content: center;
          margin-top: 0.15rem;

          .payout-countdown {
            font-size: 0.16rem;
            color: #7a8baa;
            text-align: center;
            font-weight: 600;
          }
        }
      }
    }
  }
}


// [PROMO-CODE 2026-10-14] 活动码卡片（自适应高度，不写死宽高）
.promo-card {
  margin-top: 0.2rem;
  background-color: #161c2a;
  border-radius: 0.1rem;
  padding: 0.16rem 0.24rem;
  position: relative;
  font-size: 0.16rem;
  color: #a3b2cf;

  .promo-hint {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    color: #ffffff;

    &:hover { opacity: 0.85; }
    .promo-arrow { font-size: 0.24rem; line-height: 1; color: #ffffff; }
  }

  .promo-done-text { color: #ffffff; font-size: 0.16rem; padding-right: 0.3rem; }
  .promo-done-msg { margin-top: 0.06rem; color: $active-color; font-size: 0.14rem; }

  .promo-clear {
    position: absolute;
    right: 0.14rem;
    top: 0.1rem;
    cursor: pointer;
    color: #7b8798;
    font-size: 0.22rem;
    line-height: 1;

    &:hover { color: #ffffff; }
  }
}



.promo-code-modal {
  // 垂直居中（myModal 不居中，AntD 默认 top:100px 会贴顶）
  :deep(.ant-modal-wrap) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :deep(.ant-modal) {
    top: 0;
    margin: 0 auto;
    padding-bottom: 0;
    width: 5.5rem !important;
    background-color: #0e121e;

    .ant-modal-header { padding: 0.38rem 0.5rem 0; }
    .ant-modal-title {
      height: auto;
      font-size: 0.24rem;
      font-weight: bold;
      color: #ffffff;
      line-height: 1.2;
    }
    .ant-modal-close {
      top: 0.34rem;
      right: 0.4rem;
      img { width: 0.16rem; }
    }
    .ant-modal-body { padding: 0.24rem 0.5rem 0.44rem; }
    .ant-modal-footer { display: none; }
  }
}

.promo-modal-body {
  .ant-input {
    width: 100%;
    height: 0.5rem;
    background-color: #161c2a;
    border: 1px solid #304b75;
    border-radius: 0.08rem;
    color: #ffffff;
    font-size: 0.16rem;
    padding: 0 0.18rem;

    &::placeholder { color: #7c8aa5; }
    &:hover, &:focus { border-color: #ed51af; box-shadow: none; }
  }

  .promo-modal-err {
    min-height: 0.2rem;
    margin-top: 0.1rem;
    color: #ff4d4f;
    font-size: 0.15rem;
    line-height: 0.2rem;
  }

  .promo-ok-btn {
    width: 100%;
    height: 0.5rem;
    margin-top: 0.24rem;
    border-radius: 0.25rem;
    background-color: $active-color;
    border-color: $active-color;
    color: #ffffff;
    font-size: 0.18rem;
    font-weight: bold;
  }
}

// [PROMO-CODE 2026-10-14] 礼品卡面板：活动码入口内联在「Use a gift card」标题行右侧
.promo-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .promo-title-text { flex-shrink: 0; }

  .promo-inline-link,
  .promo-inline-done {
    display: inline-flex;
    align-items: center;
    margin-left: 0.2rem;
    font-size: 0.16rem;
    font-weight: 400;
    color: #ffffff;
    text-align: right;
  }

  .promo-inline-link {
    cursor: pointer;
    &:hover { opacity: 0.85; }
  }

  .promo-inline-done { cursor: default; }

  .promo-arrow { margin-left: 0.06rem; font-size: 0.22rem; line-height: 1; color: #ffffff; }

  .promo-clear {
    margin-left: 0.1rem;
    cursor: pointer;
    font-weight: 400;
    color: #7b8798;

    &:hover { color: #ffffff; }
  }
}
</style>